// extracted by mini-css-extract-plugin
module.exports = {"btnWrap":"payroll-list_btnWrap__ndWzK","btnIn":"payroll-list_btnIn__ysbv7"};